export class ContactEmail {

    category: string;
    name: string;
    type: string;
    value: string;

    constructor(category: string,
        name: string,
        type: string,
        value: string) {
        this.category = category;
        this. name = name;
        this. type = type;
        this.value = value;
    }

}
